import React from 'react';
import { Logo } from './Logo';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark text-white pt-20 pb-8 border-t-4 border-gold" data-id="element-124">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-126">
          {/* Brand Col */}
          <div className="lg:col-span-1" data-id="element-127">
            <div className="bg-white rounded-lg px-4 py-3 inline-block mb-6 shadow-lg" data-id="element-128">
              <Logo size="lg" data-id="element-129" />
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6" data-id="element-130">
              Moving with direction, integrity, and excellence. Dallas-based,
              nationwide reach.
            </p>
            <div className="flex gap-4" data-id="element-131">
              <a href="https://www.facebook.com/CompassMovingLLC" target="_blank" rel="noopener noreferrer" aria-label="Visit Compass Moving LLC on Facebook" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-gold hover:text-navy transition-colors" data-id="element-132">
                <Facebook size={18} data-id="element-133" />
              </a>
              <a href="#" aria-label="Instagram (coming soon)" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-gold hover:text-navy transition-colors" data-id="element-134">
                <Instagram size={18} data-id="element-135" />
              </a>
              <a href="#" aria-label="LinkedIn (coming soon)" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-gold hover:text-navy transition-colors" data-id="element-136">
                <Linkedin size={18} data-id="element-137" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-138">
            <h4 className="font-serif font-bold text-lg mb-6 text-gold" data-id="element-139">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-140">
              {['Home', 'About Us', 'Our Services', 'Testimonials', 'Contact'].map(link => <li key={link} data-id="element-141">
                  <a href={`#${link.toLowerCase().replace(' ', '-')}`} className="text-white/70 hover:text-gold transition-colors text-sm" data-id="element-142">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-143">
            <h4 className="font-serif font-bold text-lg mb-6 text-gold" data-id="element-144">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-145">
              {['Residential Moving', 'Commercial Relocation', 'Long Distance', 'Packing & Unpacking', 'Corporate Relocation', 'Loading & Unloading'].map(service => <li key={service} data-id="element-146">
                  <a href="#services" className="text-white/70 hover:text-gold transition-colors text-sm" data-id="element-147">
                    {service}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-148">
            <h4 className="font-serif font-bold text-lg mb-6 text-gold" data-id="element-149">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm text-white/70" data-id="element-150">
              <li data-id="element-151">
                <strong className="block text-white mb-1" data-id="element-152">Phone</strong>
                <a href="tel:2146094606" className="hover:text-gold transition-colors" data-id="element-153">
                  214-609-4606
                </a>
              </li>
              <li data-id="element-154">
                <strong className="block text-white mb-1" data-id="element-155">Email</strong>
                <a href="mailto:compassmovingtexas@gmail.com" className="hover:text-gold transition-colors break-all" data-id="element-156">
                  compassmovingtexas@gmail.com
                </a>
              </li>
              <li data-id="element-157">
                <strong className="block text-white mb-1" data-id="element-158">
                  Mailing Address
                </strong>
                <address className="not-italic leading-relaxed" data-id="element-159">
                  PO Box 40
                  <br data-id="element-160" />
                  1097 Schoolhouse Road
                  <br data-id="element-161" />
                  Haslet, Texas 75052-9998
                </address>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50" data-id="element-162">
          <p data-id="element-163">
            &copy; {new Date().getFullYear()} Compass Moving. All rights
            reserved.
          </p>
          <p className="font-medium text-white/70 text-center md:text-right" data-id="element-164">
            More Than Moving Boxes—We're Moving Lives Forward.
          </p>
        </div>
      </div>
    </footer>;
}